import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Select,
  Button,
  Dropdown,
  Spin,
  Col,
  Input,
  Switch,
  Strong,
  Form,
  Typography,
  Checkbox,
  message,
} from 'antd';
import {
  addNewUser,
  fetchSpocUser,
} from '../../services/api/hospitalDashboard';
const { Text } = Typography;

class CreateNewUserAccount extends Component {
  constructor(props) {
    super(props);
    console.log(props, 'props');
    this.state = {
      name: null,
      email: null,
      phone: null,
      password: null,
      userName: null,
      spocId: null,
      userType: 'onsite',
      centerId: this.props.centerId,
      spocUsers: [],
      loading: false,
      isOpdCenter:false,
      isPhysioCenter:false,
      isDentalCenter:false
    };
  }

  fetchSpocUser = (value) => {
    if (value.length > 2) {
      this.setState({
        loading: true,
      });
      fetchSpocUser(value).then((res) => {
        console.log(res, 'res');
        this.setState({
          spocUsers: res.body.data.map((item) => ({
            value: item.id,
            label: item.name,
          })),
          loading: false,
        });
      });
    }
  };

  submit = () => {
    const body = {
      name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      password: this.state.password,
      userName: this.state.userName,
      spocId: this.state.spocId,
      centerId: this.state.centerId,
      userType: this.state.userType,
      currentCenterId: this.props.centerId,
      isOpdCenter: this.state.isOpdCenter,
      isDentalCenter: this.state.isDentalCenter,
      isPhysioCenter: this.state.isPhysioCenter,
    };
    if (body) {
      this.setState({ loading: true });
      addNewUser(body)
        .then((res) => {
          console.log(res, 'res');
          if (res.body.message === 'success') {
            message.success('User added successfully');
            this.props.handleClose();
            this.props.reload();
          } else {
            message.error(res.body.errorMessage || res.body.message || 'Something went wrong');
          }
        })
        .catch((err) => {
          console.log(err, 'err');
          const data = err?.response?.data;
          if (data?.err) {
            const errors = Object.values(data.err).map((e) => e.msg).join(', ');
            message.error(errors);
          } else {
            message.error(data?.message || 'Something went wrong');
          }
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    }
  };

  render() {
    console.log(this.state.spocUsers);
    return (
      <Modal
        visible={this.props.modalIsOpen}
        title="Add New User Account"
        onCancel={() => {
          this.props.handleClose();
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              this.props.handleClose();
            }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={this.state.loading}
            onClick={this.submit}
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          //   initialValues={{ remember: true }}
          //   onFinish={this.onFinish}
          //   onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item label="Name" name="name">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              onChange={(event) => {
                this.setState({
                  name: event.target.value,
                });
              }}
            />
          </Form.Item>
          <Form.Item label="User Name" name="userName">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              onChange={(event) => {
                this.setState({
                  userName: event.target.value,
                });
              }}
            />
          </Form.Item>
          <Form.Item label="Email" name="email">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              onChange={(event) => {
                this.setState({
                  email: event.target.value,
                });
              }}
            />
          </Form.Item>
          <Form.Item label="Phone" name="phone">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              onChange={(event) => {
                this.setState({
                  phone: event.target.value,
                });
              }}
            />
          </Form.Item>
          <Form.Item label="Password" name="password">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              onChange={(event) => {
                this.setState({
                  password: event.target.value,
                });
              }}
            />
          </Form.Item>
          <Form.Item label="Spoc Id" name="spocId">
            <Select
              showSearch
              filterOption={false}
              style={{ width: '50%', marginLeft: '10px' }}
              placeholder="Search Category"
              onChange={(value) => {
                this.setState({ spocId: value });
              }}
              onSearch={(value) => {
                this.fetchSpocUser(value);
              }}
              loading={this.state.loading}
            >
              {this.state.spocUsers.map((item) => {
                console.log(item, 'item');
                return (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label} - {item.value}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item label="Role" name="userType">
            <Select
              style={{ width: '50%', marginLeft: '10px' }}
              placeholder="Search Category"
              defaultActiveFirstOption={true}
              onSelect={(value) => {
                this.setState({ userType: value });
              }}
            >
              <Select.Option key={'billing'}>
                <Col>Billing</Col>
              </Select.Option>
              <Select.Option key={'central'}>
                <Col>Central</Col>
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Center Id" name="centerId">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              value={this.state.centerId}
              onChange={(event) => {
                this.setState({
                  centerId: event.target.value,
                });
              }}
            />
          </Form.Item>
          <Form.Item label="Center Type" name="centerType">
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>

              {/* Checkboxes in same row */}
              <Checkbox
                checked={this.state.isOpdCenter}
                onChange={(e) =>
                  this.setState({ isOpdCenter: e.target.checked })
                }
              >
                OPD
              </Checkbox>

              <Checkbox
                checked={this.state.isPhysioCenter}
                onChange={(e) =>
                  this.setState({ isPhysioCenter: e.target.checked })
                }
              >
                Physio
              </Checkbox>

              <Checkbox
                checked={this.state.isDentalCenter}
                onChange={(e) =>
                  this.setState({ isDentalCenter: e.target.checked })
                }
              >
                Dental
              </Checkbox>
            </div>
          </Form.Item>


        </Form>
      </Modal>
    );
  }
}

export default CreateNewUserAccount;
